import { Box, Button, TextAreaField, TextField } from '@factorialco/deprecated-design-system'

import { FormErrors, useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { CompetencyGroupSelector } from 'modules/competencies/components/CompetencyGroupSelector'
import {
  CompetencyForm,
  type SelectedCompetency,
  toSelectedCompetency,
} from 'modules/competencies/hooks/useCompetencyFinder'

type Props = {
  name: string
  onClose: () => void
  onSubmit: (competency: SelectedCompetency) => void
}

export const CreateForm = ({ name, onClose, onSubmit }: Props) => {
  const form = useForm<CompetencyForm>({
    defaultValues: {
      name,
      description: '',
      groupName: '',
    },
    validate: (data) => {
      const errors: FormErrors<CompetencyForm> = {}

      if (!data.name?.trim()) {
        errors.name = i18n.t('common.validations.empty')
      }

      return errors
    },
    onSubmit: async (data, _formikHelpers) => {
      const newCompetency = toSelectedCompetency(data, 'createNewForm')
      onSubmit(newCompetency)
      return { success: true as const, data: newCompetency }
    },
  })
  return (
    <Box
      background="grey100"
      padding="s12"
      gap="s16"
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          style: 'solid',
          width: 's2',
          color: 'grey400',
        },
      }}
    >
      <Box gap="s8" flexDirection="column">
        <TextField
          mandatory
          label={i18n.t('competencies_v3.competencies_finder.create_form.competency_name')}
          value={form.values.name}
          error={form.touched.name ? form.errors.name : undefined}
          onChange={(value: string) => form.setFieldValue('name', value)}
          selectValue=""
          missingLabel={i18n.t('competencies_v3.competencies_finder.create_form.missing_name')}
        />
        <CompetencyGroupSelector
          label={i18n.t('competencies_v3.competencies_finder.create_form.competency_group')}
          value={form.values.groupId}
          onChange={(groupId) => form.setFieldValue('groupId', groupId)}
          error={form.touched.groupId ? form.errors.groupId : undefined}
        />
        <TextAreaField
          label={i18n.t('competencies_v3.competencies_finder.create_form.description')}
          value={form.values.description || ''}
          error={form.touched.description ? form.errors.description : undefined}
          onChange={(value: string) => form.setFieldValue('description', value)}
          selectValue=""
          minRows={4}
          maxHeight="s240"
          missingLabel={i18n.t(
            'competencies_v3.competencies_finder.create_form.missing_description'
          )}
        />
      </Box>
      <Box flexDirection="row" flexGrow justifyContent="spaceBetween" gap="s4">
        <Button
          type="secondary"
          iconName="delete"
          aria-label={i18n.t('competencies_v3.competencies_finder.create_form.discard')}
          onClick={() => onClose()}
        />
        <Button iconName="save" onClick={() => form.handleSubmit()}>
          {i18n.t('competencies_v3.competencies_finder.create_form.submit')}
        </Button>
      </Box>
    </Box>
  )
}
